import React from "react";
import {Modal, Button} from "react-bootstrap";
import {translate} from "../../i18n/translate.js";
import styles from "../../css/common/popup.less";

class ModalPopup extends React.Component {
    closeModal = () => {
        if (this.props.onClose)
            this.props.onClose.apply();
    };

    render() {
        if (!this.props.middle && !this.props.right)
            return null;
        return (
            <Modal className="modal-popup" show={true} onHide={this.closeModal}>
                <Modal.Body>
                    {this.props.title ?
                        <div className="modal-title" dangerouslySetInnerHTML={{__html:translate(this.props.title)}}/>
                        : undefined
                    }
                    <div className="modal-message" dangerouslySetInnerHTML={{__html:translate(this.props.message)}}/>
                    {this.props.middle ?
                        <div className="one-button">
                            <Button id="modalButton" className="button" bsStyle="primary"
                                    onClick={this.props.middle.callback}>{translate(this.props.middle.text)}</Button>
                        </div>
                        :
                        <div className="two-buttons">
                            <Button id="modalPopupRightButton" className="button pull-right" bsStyle="primary"
                                    onClick={this.props.right.callback}>{translate(this.props.right.text)}</Button>
                            <Button id="modalPopupLeftButton" className="button pull-left leave"
                                    onClick={this.props.left.callback}>{translate(this.props.left.text)}</Button>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        );
    }
}

export default ModalPopup;


// WEBPACK FOOTER //
// ./src/components/common/ModalPopup.js